import { useMutation, useQueryClient } from '@tanstack/react-query';
import { userService } from '@services/user';
import { toast } from 'react-toastify';
import { useTranslation } from '@hooks/useTranslation';

export const useToggleUserStatus = () => {
  const tActionMessages = useTranslation('actionMessages');
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['users', 'toggleStatus'],
    mutationFn: async ({ userId, enable }: { userId: string; enable: boolean }) => {
      if (enable) {
        return await userService.enableUser(userId);
      } else {
        return await userService.disableUser(userId);
      }
    },
    onSuccess: (_, { enable }) => {
      queryClient.invalidateQueries({ queryKey: ['users'] });
      toast.success(enable ? tActionMessages.userEnabledSuccessfully : tActionMessages.userDisabledStatusSuccessfully);
    },
    onError: (error: any) => {
      console.error('Toggle user status error:', error);
      const errorMessage =
        error?.response?.errors?.[0]?.message ||
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        error?.message ||
        error?.toString() ||
        'Failed to update user status';
      toast.error(errorMessage);
    },
  });
};

export default useToggleUserStatus;